export type Ticker = { id: number; tag: string; text: string; time: string };
export type TimelineItem = { id: number; time: string; title: string; body: string; tag: string; status: "new" | "updating" | "digging" };
export type Zone = { id: number; key: string; title: string; desc: string; posts: number; image: string; accent: "primary" | "accent" | "secondary" };
export type Truth = { id: number; title: string; summary: string; progress: number; comment: number; image: string; label: string };
export type Mystery = { id: number; title: string; clueCount: number; state: string };
export type Tip = { id: number; who: string; code: string; trust: number; text: string; replies: number; up: number; source: string };
export type Thread = { id: number; title: string; tag: string; views: string; replies: string; last: string; hot: string; users: string[] };
export type RankItem = { id: number; title: string; heat: number; delta: "up" | "down" | "flat"; chip: string };

export const ticker: Ticker[] = [
  { id: 1, tag: "新料", text: "知情人士再放料：某头部 MCN 年底大洗牌，多位签约主播被要求在保密协议上签字。", time: "刚刚" },
  { id: 2, tag: "更新", text: "上一轮深扒「某连锁餐饮后厨监控」已补入三张现场图，点击进入线索墙查看。", time: "12 分钟前" },
  { id: 3, tag: "求证", text: "关于某明星品牌联名款的账目疑问，财务口径与公开财报存在出入，正在交叉核对。", time: "38 分钟前" },
  { id: 4, tag: "归档", text: "「某直播基地空置率」一贴已整理为长期档案，评论区新增 400+ 讨论。", time: "1 小时前" },
];

export const timeline: TimelineItem[] = [
  { id: 1, time: "09:41", title: "一线：某总部大楼深夜亮灯的第三层", body: "多名网友拍到某头部互联网公司总部第三层连续第七夜亮灯，结合近期高管集中换防，矛头指向一次未公开的组织调整。", tag: "实时", status: "new" },
  { id: 2, time: "11:07", title: "实锤进展：品牌联名款账目，三处对不上", body: "对照公开投流数据与店铺销量，账面上的「售罄补货」与实际库存水位并不一致，知情人士表示差额去向待查。", tag: "深扒中", status: "digging" },
  { id: 3, time: "14:22", title: "旧瓜新挖：三年前那场「临时改期」直播", body: "本是一次寻常的档期调整，如今回看嘉宾阵容变动与后续解约公告，时间线咬合得异常紧密。", tag: "复盘", status: "updating" },
  { id: 4, time: "16:50", title: "新面孔进场：多位「素人」晒出同一份通告", body: "同一时间、同一行程、同一话术的晒单集中出现，被指疑似同一套孵化链路在下沉市场的第一次试水。", tag: "可疑", status: "new" },
];

export const zones: Zone[] = [
  {
    id: 1,
    key: "truth",
    title: "背后真相",
    desc: "把散落的公开信息拼回原貌，讲清楚一件事到底是怎么发生的。",
    posts: 186,
    image: "https://readdy.ai/api/search-image?query=moody%20cinematic%20close-up%20of%20a%20magnifying%20glass%20over%20scattered%20newspaper%20clippings%20and%20torn%20documents%20on%20a%20dark%20wooden%20desk%2C%20warm%20amber%20lamp%20glow%2C%20deep%20charcoal%20shadows%2C%20investigation%20mood%2C%20film%20grain%2C%20high%20detail%20editorial%20photography&width=900&height=900&seq=chip-zone-truth&orientation=squarish",
    accent: "primary",
  },
  {
    id: 2,
    key: "mystery",
    title: "未解之谜",
    desc: "还没答案的事，我们先把已知的线索一条条摆上桌，等你一起补全。",
    posts: 74,
    image: "https://readdy.ai/api/search-image?query=dark%20enigmatic%20abandoned%20control%20room%20with%20glowing%20orange%20terminal%20screens%20and%20scattered%20cables%2C%20single%20flickering%20warm%20light%2C%20thin%20fog%2C%20mysterious%20atmosphere%2C%20charcoal%20and%20amber%20palette%2C%20film%20grain%20cinematic&width=900&height=900&seq=chip-zone-mystery&orientation=squarish",
    accent: "accent",
  },
  {
    id: 3,
    key: "insider",
    title: "知情人士",
    desc: "来源不明的消息先标注可信度，再放进整理好的线索墙里交叉比对。",
    posts: 240,
    image: "https://readdy.ai/api/search-image?query=silhouette%20of%20a%20person%20speaking%20low%20behind%20a%20frosted%20glass%20partition%20in%20a%20dim%20corridor%2C%20single%20warm%20desk%20lamp%2C%20noir%20mystery%20mood%2C%20deep%20shadows%2C%20film%20grain%20editorial&width=900&height=900&seq=chip-zone-insider&orientation=squarish",
    accent: "secondary",
  },
  {
    id: 4,
    key: "archive",
    title: "深扒档案",
    desc: "事件尘埃落定后也保留完整档案，谁提过、谁反驳、结论是什么，都能追溯。",
    posts: 392,
    image: "https://readdy.ai/api/search-image?query=neat%20archive%20shelves%20in%20a%20dim%20storage%20basement%20filled%20with%20labeled%20file%20boxes%2C%20warm%20ceiling%20bulb%20glow%2C%20dust%20in%20a%20light%20beam%2C%20deep%20charcoal%20shadows%2C%20archival%20investigative%20mood%2C%20film%20grain%20cinematic&width=900&height=900&seq=chip-zone-archive&orientation=squarish",
    accent: "primary",
  },
];

export const truths: Truth[] = [
  {
    id: 1,
    title: "某头部直播平台的「买量」真相：谁在为你的每一次下单买单",
    summary: "投流后台的消耗曲线与上播时段高度重合，我们翻出三份公开投放报告，把背后的流量分配逻辑拆给你看。",
    progress: 82,
    comment: 1240,
    label: "平台 · 流量",
    image: "https://readdy.ai/api/search-image?query=dim%20data%20center%20corridor%20with%20rows%20of%20server%20racks%20lit%20by%20muted%20red%20and%20warm%20amber%20warning%20lights%2C%20a%20hooded%20analyst%20figure%20inspecting%20a%20glowing%20console%2C%20behind%20the%20scenes%20mystery%2C%20deep%20charcoal%20shadows%2C%20film%20grain%20cinematic%20documentary&width=1000&height=700&seq=chip-truth-a&orientation=landscape",
  },
  {
    id: 2,
    title: "一场颁奖礼的后台：座次表的「临时调整」藏着谁的面子",
    summary: "从公开彩排图到直播机位，同一批位置在两天内反复变动。我们把能看到的每一帧都钉在了时间线上。",
    progress: 61,
    comment: 878,
    label: "文娱 · 后台",
    image: "https://readdy.ai/api/search-image?query=backlit%20stage%20curtain%20with%20a%20lone%20microphone%20and%20empty%20rows%20of%20red%20velvet%20chairs%2C%20single%20warm%20amber%20spotlight%2C%20backstage%20scandal%20mood%2C%20deep%20shadows%2C%20editorial%20documentary%20cinematic%2C%20film%20grain&width=1000&height=700&seq=chip-truth-b&orientation=landscape",
  },
  {
    id: 3,
    title: "凌晨四点的带货直播间：灯没亮，人在哪里",
    summary: "一场宣称「真实抢购」的直播，实际在播画面与库存数字之间存在时间差，我们截下了全程录屏做比对。",
    progress: 47,
    comment: 2031,
    label: "直播 · 实况",
    image: "https://readdy.ai/api/search-image?query=dim%20empty%20live-stream%20studio%20with%20ring%20light%20partially%20off%2C%20scattered%20cables%20and%20a%20glowing%20laptop%2C%20empty%20host%20chair%2C%20behind%20the%20scenes%20truth%20investigation%2C%20warm%20charcoal%20tones%2C%20film%20grain%20cinematic&width=1000&height=700&seq=chip-truth-c&orientation=landscape",
  },
];

export const mysteries: Mystery[] = [
  { id: 1, title: "那个「一夜消失」的头部玩家，究竟去了哪家竞对", clueCount: 14, state: "线索 3 条已实锤" },
  { id: 2, title: "三年前那条深夜删帖，为什么现在又被人翻出来", clueCount: 9, state: "待新证" },
  { id: 3, title: "同一批「素人种草」背后的孵化方，始终查不到公开股东", clueCount: 21, state: "档案最全" },
  { id: 4, title: "官方口径与民间记录的矛盾点，到底哪一版是真的", clueCount: 12, state: "交叉核实中" },
];

export const tips: Tip[] = [
  { id: 1, who: "知情人士 · A 君", code: "线索墙 / 编号 0118", trust: 86, text: "在总部做过两年投后尽调，那笔「并购」的价格其实按两套账在算，公开报道只是其中一套，差额去向已有出处。", replies: 320, up: 1804, source: "曾任职 · 总部" },
  { id: 2, who: "知情人士 · 老七", code: "线索墙 / 编号 0203", trust: 71, text: "颁奖礼座次调整那天，我看过那份应急名单，上面三个名字本来根本不在行程里，是当天早上才临时加的。", replies: 191, up: 966, source: "现场工作人员" },
  { id: 3, who: "知情人士 · MOMO", code: "线索墙 / 编号 0236", trust: 58, text: "那位「素人」我记得，半年前还在品牌方做过商务，现在话术一模一样，只是换了个脸。手上还有当时的排期表。", replies: 445, up: 2210, source: "前从业者" },
];

export const threads: Thread[] = [
  { id: 1, title: "总部第三层连亮七夜，这层到底藏了多少" , tag: "热聊", views: "86.3w", replies: "3.2w", last: "2 分钟前", hot: "已爆", users: ["咖", "叙", "夜", "澄"] },
  { id: 2, title: "这张联名款对账单，大家帮我看看问题出在哪", tag: "求锤", views: "21.8w", replies: "9,400", last: "8 分钟前", hot: "热议", users: ["南", "谷", "眠", "九"] },
  { id: 3, title: "旧直播回放挖出来的那三秒，有人逐帧看过了吗", tag: "复盘", views: "12.4w", replies: "5,100", last: "21 分钟前", hot: "持续", users: ["阿", "鱼", "葵", "杳"] },
  { id: 4, title: "新通告话术高度统一，会不会是同一套链路在试水", tag: "可疑", views: "9.1w", replies: "3,300", last: "35 分钟前", hot: "待解", users: ["麦", "舟", "一", "吟"] },
];

export const ranks: RankItem[] = [
  { id: 1, title: "某头部平台「买量」账目疑云", heat: 98, delta: "up", chip: "背后真相" },
  { id: 2, title: "总部大楼连亮七夜的第三层", heat: 95, delta: "up", chip: "未解之谜" },
  { id: 3, title: "联名款公开财报对不上的三处", heat: 91, delta: "up", chip: "深扒中" },
  { id: 4, title: "那个「一夜消失」的头部玩家", heat: 87, delta: "down", chip: "未解之谜" },
  { id: 5, title: "颁奖礼座次表的临时调整", heat: 84, delta: "flat", chip: "背后真相" },
  { id: 6, title: "「素人」晒单背后的孵化链", heat: 79, delta: "up", chip: "可疑" },
  { id: 7, title: "凌晨直播的库存时间差", heat: 74, delta: "flat", chip: "直播 · 实况" },
  { id: 8, title: "深夜删帖为何又被翻出", heat: 68, delta: "down", chip: "复盘" },
  { id: 9, title: "后厨监控里的三处细节", heat: 63, delta: "up", chip: "深扒中" },
  { id: 10, title: "孵化方查不到公开股东之谜", heat: 55, delta: "down", chip: "档案最全" },
];

export const heroCover = "https://readdy.ai/api/search-image?query=dark%20editorial%20cinematic%20still%20of%20a%20dim%20high-rise%20financial%20district%20at%20night%20shot%20from%20behind%20a%20giant%20frosted%20glass%20panel%20streaked%20with%20rain%2C%20tiny%20glowing%20amber%20and%20lime%20city%20lights%20bleeding%20through%2C%20deep%20charcoal%20and%20ink%20black%20tones%2C%20single%20dramatic%20warm%20light%2C%20investigative%20mystery%20atmosphere%2C%20heavy%20film%20grain%2C%20high%20detail%20editorial%20photography&width=1400&height=1000&seq=chip-hero-cover&orientation=landscape";

export const heroStory = {
  kicker: "今日头号深扒",
  title: "某头部平台「买量」账本背后：一份对不上的投流对账单",
  lede: "当公开投放曲线与内部结算口径出现 4000 万级差额，我们顺着知情人士的线索整理，把散落的碎片逐条拼回时间线。",
  tags: ["背后真相", "投流对账", "知情人士线索"],
  statViews: "86.3 万阅读",
  statComments: "12,400 讨论",
  statUpdated: "2 分钟前更新",
  coords: "深扒进度 82%",
};

export const mysteryClues = [
  { id: 1, who: "线索 A", text: "当晚值班日志显示，该账号在停播前 40 分钟仍处于「在线彩排」状态。" },
  { id: 2, who: "线索 B", text: "同一 IP 段在另一省开过同名小号，注册手机尾号与已知员工重号。" },
  { id: 3, who: "线索 C", text: "竞对总部停车场监控被拍到同款车，时间点高度吻合。" },
];

export const rankTexts = ["TOP 1", "TOP 2", "TOP 3", "TOP 4", "TOP 5", "TOP 6", "TOP 7", "TOP 8", "TOP 9", "TOP 10"];